<template>
  <div :id="id" class="section-heading">
    <h2 class="no-margin-top">{{ text }}</h2>
    <hr>
  </div>
</template>

<script>
export default {
  name: 'SectionHeading',
  props: {
    id: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="less" scoped>
.section-heading {
  margin-top: 6em;
}
</style>
